import { Button, FieldError, Form, Input, Label, TextField } from 'react-aria-components';
import LoadingApp from 'components/base-elements/loading/LoadingApp';
import { LoginMode } from '@layouts/login-app/LoginMode';
import useLoginApp from '@layouts/login-app/useLoginApp';



const LoginApp = () => {

	const [ loginMode, isLoading, handleSubmit, validateEmail ] = useLoginApp();


	if (isLoading || loginMode === LoginMode.checkToken) return (
		<LoadingApp />
	)


	return (
		<div className="lfmt-login">

			<h1>Přihlášení uživatele</h1>
			
			<Form onSubmit={handleSubmit}>

				<TextField name='username' type='email' inputMode='email' validate={validateEmail} isDisabled={isLoading} isRequired>
					<Label>Emailová adresa:</Label>
					<Input maxLength={50} placeholder='E-mail' />
					<FieldError />
				</TextField>
				
				<TextField name='password' type='password' isDisabled={isLoading} isRequired>
					<Label>Heslo:</Label>
					<Input maxLength={100} placeholder='Heslo' />
					<FieldError />
				</TextField>
			
				<div>
					<Button type='submit' isDisabled={isLoading}>Přihlásit</Button>
				</div>
			
			</Form>

			{loginMode === LoginMode.loginFailed &&
				<p>Přihlášení se nezdařilo, zkusto to prosím znovu</p>}

		</div>
	);
};

export default LoginApp;